import { DateTimeISO } from "shared-ts-types";
import { DateTime, ToISOTimeOptions } from "luxon";
import { DateTimeUtils } from "./DateTimeUtils";
import { DateTimeUnit } from "luxon";

declare module "luxon" {
  interface DateTime {
    /**
     * Throws if invalid.
     */
    toIsoOrThrow(options?: ToISOTimeOptions): DateTimeISO;

    /**
     * Converts given DateTime to utc before transforming to the ISO string. Throws if invalid.
     */
    toUtcIsoOrThrow(options?: ToISOTimeOptions): DateTimeISO;

    toTruncatedIso(timeUnit: DateTimeUnit): string;
  }
}

DateTime.prototype.toIsoOrThrow = function (
  this: DateTime,
  options?: ToISOTimeOptions
): DateTimeISO {
  return DateTimeUtils.toIso(this, options);
};

DateTime.prototype.toUtcIsoOrThrow = function (
  this: DateTime,
  options?: ToISOTimeOptions
): DateTimeISO {
  return DateTimeUtils.toUtcIso(this, options);
};

DateTime.prototype.toTruncatedIso = function (
  this: DateTime,
  timeUnit: DateTimeUnit
): string {
  return DateTimeUtils.toTruncatedIso(this, timeUnit);
};
